module.exports = "/_next/static/images/ca4cb193d32b6d426d45adf26d569bd1-paperwork@mobile320.jpg.webp";